<div class="current-user-container" [ngClass]="{active: popupVisibility.user}" (click)="toggleUserMenu(); $event.stopPropagation();">
  @if (currentUser != null) {
    <opm-user-photo [user]="currentUser"></opm-user-photo>
  }
  <div id="toggle-button" class="toggle-user-menu-button"></div>
  @if (popupVisibility.user) {
    <div id="{{popupId}}" class="user-menu">
      @if (currentUser != null) {
        <opm-user-photo [user]="currentUser"></opm-user-photo>
      }
      <div class="user-info">
        <div class="name">{{currentUser?.PreferredFullName}}</div>
      </div>
      <div class="logout" (click)="logout()">Logout</div>
    </div>
  }
</div>
